import { customScrollMinimal, SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const TabContent = styled.div`
  padding: 12px;
  background-color: var(--surface-default);
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const Wrapper = styled.div`
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  ${customScrollMinimal};
  position: relative;
  overflow: auto;
  flex: 1 1 0;
  padding table {
    tbody {
      tr > td:nth-child(n + 2) {
      }
    }
  }
  &::-webkit-scrollbar-track {
    margin-left: 207px;
  }
`;

export const TableLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
      },
    },
  ],
})`
  height: 100%;
`;

export const AssetCell = styled.div`
  display: flex;
`;

export const CellWithChartContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
`;
